export const mapOptions = {
    GoogleMapsAPI : 'AIzaSyAqn7q_9-GV3balsnk94-FgODIu_8lT3oM',
}